import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"; // To call Action Creators
import { BrowserRouter as Router, Routes, Route, Link, Navigate, Outlet } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { actionCreators } from "../state";
// import { State } from "./state";
import { State } from '../state/reducers';
import "./App.scss";
import _ from 'lodash';

// import component
import Homepage from "./components/Homepage";
import LoginPage from "./components/UserPage/Login";
import RegisterPage from "./components/UserPage/Register";
import VerifyEmailPage from "./components/UserPage/VerifyEmail";

import { checkToken } from './components/UserPage/Login/LoginForm';

import { systemName}  from '../types/data.global';


// import * as d3 from  "d3";
// import { flatGroup, select as d3Select } from 'd3';
import { ConfigProvider, Layout } from 'antd';
import { GlobalTypes } from "../types/data";
const { Header, Content, Footer } = Layout;



const App: React.FC = () => {

  const PrivateRoute: React.FC = () => {
    // If authenticated, render children routes defined within this component
    if (checkToken()){
      // setIsLoginPage(false);
      return <Homepage />
    } else {
      return <Navigate to="/login" replace />;
    }
  };

  // useEffect(() => {
  //   if (true) {
  //     const updateBarchartView = async () => {
  //       try {
  //         console.log("==> in App.tsx, loading data...")
  //         await getBackendData("test test")
  //         // await getBarChartData('test barchart')
  //         // console.log('getResearcherPaperIDList:', selectedResearcherPaperList);
  //       } catch (error) {
  //         console.error(error);
  //         // setIsResearcherDetailsViewLoading(false)
  //       } finally {
  //         //console.log('Researcher View update finished');
  //         // setIsResearcherDetailsViewLoading(false)
  //       }
  //     }
  //     updateBarchartView();
  //   }
  //   // fetchData();
  // }, [])


  // create a list of dashboard, using lazy loading (only add new chart, but not re-render old charts)
  let dashboardList: JSX.Element[] = []

  // // test data
  // if (testSpecList && testSpecList.length > 0) {

  //   dashboardList = testSpecList.map((item: GlobalTypes.ChartData, index: number) => {
  //     const spec = {
  //             ...item.vegaLiteSpec,
  //             data: _.cloneDeepWith(item.vegaLiteSpec.data, (value) => {
  //               // Return undefined to handle value as lodash's cloneDeep would
  //               return undefined;
  //             })
  //           }
  //     return (
  //       <Dashboard key={index} chartID={item.chartID} spec={spec} />
  //     )
  //   })
  // }
  // // real data
  // if (chartSpecList && chartSpecList.length > 0) {
  //   dashboardList = chartSpecList.map((item: GlobalTypes.ChartData, index: number) => {
  //     const spec = {
  //       ...item.spec,
  //       data: _.cloneDeepWith(item.spec.data, (value) => {
  //         // Return undefined to handle value as lodash's cloneDeep would
  //         return undefined;
  //       })
  //     }
  //     return (
  //       <Dashboard key={index} spec={spec}/>
  //     )
  //   })
  // }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: 'white', // https://ant.design/docs/react/customize-theme
          colorSplit: 'rgba(5, 5, 5, 0.06)',
          colorText: '#4e4e4e',
          colorBgLayout: 'white', // '#f5f5f5', // backgournd
        },
        components: {
          Radio: {
            radioSize: 12,
            dotSize: 6,
          },
          Form: {
            labelFontSize: 13,
            itemMarginBottom: 6,
          },
          Slider: {
            // Customize slider text/tooltip font size
            fontSize: 12, // This controls the overall font size for slider
            controlSize: 8,
            dotSize: 6,
          },
          Select: {
            optionFontSize: 12,
          },
          Tooltip: {
            // This controls tooltip font size (including slider tooltips)
            fontSize: 12,
          },
        },
      }}
    >
    <Router>
     <Layout className="App">
      {/* <Header style={{ background: '#f7f7f7', padding: '0 20px', marginBottom: '20px' }}>
        <h1 style={{ color: '#482476', margin: 0 }}>{systemName}</h1>
      </Header> */}
      <Content>
          <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />}/>
          <Route path ="/verify-email/:token" element={<VerifyEmailPage />}/>
          <Route path="/" element={<PrivateRoute />}>
            <Route path="/*" element={<Homepage />} />
          </Route>
          {/* <div className='layout'>
            <div className='left-div'>
              <Panel viewTitle={'Ask Question'} panelHeaderHeight={64}>
                <LUIView />
              </Panel>
            </div>
            <div className='right-div'>
              <Panel viewTitle={'Dashboard Exploration'} panelHeaderHeight={64}>
                <div className="dashboard-view-div">
                  1. test
                  <Dashboard spec={{}}/>

                  2. real code
                  {dashboardList}
                </div>
              </Panel>
            </div>
          </div> */}
        </Routes>
      </Content>
      {/* <Footer style={{ textAlign: 'center', background: '#482476', marginTop: '48px', color: 'white' }}>
        {systemName} ©{new Date().getFullYear()} CSSI
      </Footer> */}
    </Layout>
  </Router>
    </ConfigProvider>
  );
}

export default App;
